/* eslint-disable complexity */
/* eslint-disable functional/no-loop-statement */
/* eslint-disable no-restricted-imports */
import { contentManifest } from '@/components/content/manifest';
import { ContentItem } from '@/data/types/LayoutAllSlots';
import { getContentNameFromWidgetName } from '@/data/utils/getContentNameFromWidgetName';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

export const getLegacyContentNameFromWidgetName = (
	contentItem: ContentItem
): string | undefined => {
	const contentManifestData = { ...contentManifest };
	delete contentManifestData['Header'];
	delete contentManifestData['Footer'];

	const contentManifestKeys = Object.keys(contentManifestData);

	const widgetName = getValueByPathFromUnknown(contentItem, ['widgetName']);
	const widgetNameByRaw = getValueByPathFromUnknown(contentItem, ['widgetRaw', 'widgetName']);
	const emsName = getValueByPathFromUnknown(contentItem, ['properties', 'emsName']);

	for (const key of contentManifestKeys) {
		if (
			valueIsString(widgetNameByRaw) &&
			getContentNameFromWidgetName(widgetNameByRaw).includes(key)
		) {
			return key;
		}

		if (valueIsString(widgetName) && getContentNameFromWidgetName(widgetName).includes(key)) {
			return key;
		}

		if (valueIsString(emsName) && getContentNameFromWidgetName(emsName).includes(key)) {
			return key;
		}

		if (contentItem.name && getContentNameFromWidgetName(contentItem.name).includes(key)) {
			return key;
		}
	}

	return undefined;
};
